var $09e991522ca7e64e$exports = {};
// @ts-nocheck
/* eslint-disable no-undef */ /* eslint-disable no-unused-vars */ "use strict";
const $09e991522ca7e64e$var$swiper = new Swiper(".swiper", {
    // Optional parameters
    direction: "horizontal",
    // centeredSlides: true,
    spaceBetween: 20,
    slidesPerView: "auto",
    effect: "slide",
    // If we need pagination
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});
/* #region hide menu icon on click */ const $09e991522ca7e64e$var$menuIcon = document.querySelector(".page__menu-icon-img");
const $09e991522ca7e64e$var$closeIcon = document.querySelector(".menu__close-link");
const $09e991522ca7e64e$var$menuLinks = document.querySelectorAll(".menu__nav-list .menu__nav-list-item");
$09e991522ca7e64e$var$menuIcon?.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$menuIcon.classList.toggle("page__menu-icon-img--hide-show");
});
$09e991522ca7e64e$var$closeIcon?.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$menuIcon.classList.toggle("page__menu-icon-img--hide-show");
});
$09e991522ca7e64e$var$menuLinks?.forEach((node)=>{
    node?.addEventListener("click", ()=>{
        $09e991522ca7e64e$var$menuIcon.classList.toggle("page__menu-icon-img--hide-show");
    });
}); /* #end hide menu icon on click */ 


//# sourceMappingURL=index.553925f2.js.map
